import { ThemeProvider } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const FusePageSimpleHeader = ({ classes, header }) => {
	const mainThemeDark = useSelector(({ fuse }) => fuse.settings.mainThemeDark);

	return (
		<div className={classes.header}>
			{header ? <ThemeProvider theme={mainThemeDark}>{header}</ThemeProvider> : null}
		</div>
	);
};

export default FusePageSimpleHeader;
